module.exports = __webpack_public_path__ + "img/instruction3.f5b743a3.png";